function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Style-Specs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-816.000000, -945.000000)",
  fill: "#000000",
  fillRule: "nonzero",
  id: "Group-18"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(532.000000, 188.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(286.000000, 758.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-30"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_filter",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M-0.351882363,0.454893631 L5.12864669,7.42544074 L5.12864669,13.4130028 L6.8694966,12.4057627 L6.8694966,7.42542677 L7.0251138,7.22751514 L12.3556565,0.454893631 L-0.351882363,0.454893631 Z M-1.79321402,0.968312957 L-1.83575632,0.899039954 C-1.94395628,0.709307062 -2,0.49366389 -2,0.272568174 C-2,-0.430703805 -1.42918392,-0.999989099 -0.726854968,-0.999989099 L12.7242144,-0.99997519 C13.4290452,-1.0043348 14,-0.433574496 14,0.27070771 C14,0.488287276 13.944088,0.699205094 13.8210646,0.921801361 L13.747834,1.03110433 L8.32404205,7.92900182 L8.32404205,12.5162808 C8.32404205,12.9733792 8.0798155,13.3876134 7.64500431,13.6405544 L7.61419549,13.6535949 L5.50962033,14.8701473 L5.47784983,14.8849893 C5.31216934,14.9612668 5.13214726,15 4.94724627,15 C4.24491732,15 3.67410124,14.4307147 3.67410124,13.7274427 L3.67410124,7.92879596 L-1.79321402,0.968312957 Z",
  id: "Path"
})))))));

function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.229216ce.svg";
export { ForwardRef as ReactComponent };